<div class="structuredProcessChat_container">
    @if (!isEmpty && !isLoading){
        <div class="structuredProcessChat_messagesCotainer" [ngClass]="{'is-mobile-view': isMobileView}" #chatMessagesContainer (scroll)="onMessagesScroll()">
            @if (isLoadingOlderMessages){
                <mat-spinner class="structuredProcessChat_olderMessagesSpinner" [diameter]="24"></mat-spinner>
            }
            @for(currMessage of chatMessages; track currMessage.id){
                <div class="structuredProcessChat_singleMessageContainer">
                    <app-chat-message 
                    class="structuredProcessChat_message" 
                    [messageText]="currMessage.content" 
                    [isUserMessage]="currMessage.role == chatMessageRoles.USER"
                    [isLiveMessage]="false"
                    [userRating]="currMessage.userRating"
                    (messageLikedEvent)="messageLiked(currMessage.id)"
                    (messageDislikedEvent)="messageDisliked(currMessage.id)"
                    [ngClass]="{'user' : currMessage.role == chatMessageRoles.USER, 'server' : currMessage.role == chatMessageRoles.SERVER, 'is-mobile-view' : isMobileView}">
                </app-chat-message>
                </div>
            }
            @if(presentLiveMessage){
                <app-chat-message 
                class="structuredProcessChat_message" 
                [messageText]="liveMessage" 
                [isUserMessage]="false"
                [isLiveMessage]="true"
                [ngClass]="{'server' : true, 'is-mobile-view' : isMobileView}">
            </app-chat-message> 
            }            
        </div>
    }
    @if (isLoading){
        <mat-spinner [diameter]="60"></mat-spinner>
    }

    <app-chat-user-prompt 
        #userPrompt 
        class="structuredProcessChat_userPrompt" 
        [ngClass]="{'is-mobile-view': isMobileView}" 
        [presentForceUseCases]="false " 
        (submitUserEntryEvent)="submitUserEntry($event)">
    </app-chat-user-prompt>
</div>
